import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountQueryKey } from "../account.keys";

export const useAdminFetchAccount = (id?: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: id ? accountQueryKey(id) : [],
		queryFn: async () =>
			await get<Dtos.Admin.Account.Get.Response>(`/v2/admin/surety/accounts/${id}`),
		enabled: !!id,
		retry: false,
	});

	return {
		account: data,
		accountError: error,
		accountIsLoading: isLoading,
	};
};
